import { create } from "zustand";
import { addEvent } from "./api_layer";
import { ENV } from "../../config/env";

export const useAddEvent = create((set) => ({
  error: null,
  addEventData: async (payload) => {
    try {
      if(payload?.email && payload?.first_name && payload?.user_id){
        if(ENV === 'prod'){
          await addEvent(payload);
        }
      } else {
        console.error("Missing required user information");
      }
      set({ error: null });
    } catch (error) {
      console.error(error);
      set({ error: error.message });
    }
  },
}));